import React from 'react';

const MeetOurTeam = () => {
	return (
		<section className="meet_team_area sec_pad">
			<img className="h_leaf one wow fadeInUp" data-wow-delay="0.4s" src={require("../img/new-home/tree-left.png")} alt="" />
			<img className="h_leaf two wow fadeInUp" data-wow-delay="0.6s" src={require("../img/new-home/tree-right.png")} alt="" />
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6 col-md-6">
						<div className="team_content wow fadeInLeft" data-wow-delay="0.3s">
							<div className="sec_title mb_30">
								<h2 className="f_p f_size_30 l_height50 f_600 t_color3">Meet Our Team</h2>
								<p className="f_400 f_size_16 mb_20">
									Get to know the amazing people behind MakerGram! Our diverse team of innovators, 
									creators, and problem-solvers work together to bring you the best maker experiences.
								</p>
								<p className="f_400 f_size_16 mb-0">
									Explore our interactive team map to see where our talented team members are located 
									around the world and learn more about their expertise and contributions to the MakerGram community.
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-6">
						<div className="team_map_container wow fadeInRight" data-wow-delay="0.5s">
							<div className="team_map_wrapper">
								<iframe
									src="https://plotifyd.com/09875c5e-720c-4e7c-bd28-09fc5fa3f132"
									width="100%"
									height="400"
									frameBorder="0"
									loading="lazy"
									title="Team Map Demo"
								></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default MeetOurTeam;
